var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreece(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m495.484 107h-374.484l-11.81-16.161h-36.703l-10.82 16.161h-52.667v293.975h486.484l16.516-16.516v-36.703l-13-18.256 13-18.446v-36.703l-13-19.018 13-17.684v-36.703l-13-16.946 13-19.757v-36.702z",
    fill: "#f2f2f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.516 355.097v-199.097l-16.516 8.243v36.703l7.75 6.804v58.25l-7.75 8.351v36.703l7.667 7.613v22l-7.667 7.089v36.703l6.875 7.666 19.277-7.672c-6.056-8.215-9.636-18.367-9.636-29.356z",
    fill: "#e1e1e6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5055a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m181.677 164.243h330.323v36.703h-330.323z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.333 107.355v47.645l9.183 9.243h55.971v-73.404h-55.971z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 260 8.516 14.351h55.971v-73.405h-55.971l-8.516 13.304z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m181.677 237.649v-36.703h-72.487v73.405h402.81v-36.702z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.167 320.5v17.5l7.349 9.756h495.484v-36.702h-495.484z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.145 384.459 5.855 29.041h470l10-8.855v-20.186z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m26.145 384.459h-26.145v20.186c0 9.121 7.395 16.516 16.516 16.516h478.968c9.121 0 16.516-7.395 16.516-16.516h-445.935c-16.36 0-30.897-7.963-39.92-20.186z",
    fill: "#3f3f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 311.053h16.516v36.703h-16.516z",
    fill: "#3f3f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.484 90.839h-386.294v73.405h72.487v-36.702h330.323v-20.186c0-9.123-7.395-16.517-16.516-16.517z",
    fill: "#5055a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 200.946h16.516v73.405h-16.516z",
    fill: "#3f3f8f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.516 90.839c-9.121 0-16.516 7.394-16.516 16.516v56.889h16.516z",
    fill: "#3f3f8f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreece);
export default __webpack_public_path__ + "static/media/greece.c390ea3289871a05a94fe235e212853f.svg";
export { ForwardRef as ReactComponent };